// components/ImageGallery.jsx
import React, { memo } from "react";
import Image from "next/image";
import { ZoomIn } from "lucide-react";

const ImageGallery = memo(
  ({
    images,
    currentImage,
    setCurrentImage,
    isOutOfStock,
    isDesktop,
    isZoomed,
    setIsZoomed,
    mousePosition,
    handleMouseMove,
  }) => (
    <div
      className={`lg:w-1/2 p-4 md:p-6 lg:p-8 bg-gray-100 ${
        isOutOfStock ? "pointer-events-none" : ""
      }`}
    >
      <div
        className={`relative aspect-square rounded-xl md:rounded-2xl overflow-hidden shadow-lg ${
          isDesktop && !isOutOfStock ? "group cursor-zoom-in" : ""
        }`}
        onMouseEnter={() => isDesktop && !isOutOfStock && setIsZoomed(true)}
        onMouseLeave={() => isDesktop && setIsZoomed(false)}
        onMouseMove={handleMouseMove}
      >
        {images?.[currentImage] && (
          <>
            <Image
              src={images[currentImage]}
              alt={`Product image ${currentImage + 1}`}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              className={`object-cover transform transition-all duration-300 ${
                isZoomed && isDesktop ? "opacity-0" : "opacity-100"
              } ${isOutOfStock ? "grayscale" : ""}`}
              priority={currentImage === 0}
            />
            {isDesktop && !isOutOfStock && (
              <div
                className={`absolute inset-0 transition-opacity duration-300 ${
                  isZoomed ? "opacity-100" : "opacity-0"
                }`}
                style={{
                  backgroundImage: `url(${images[currentImage]})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "200%",
                  backgroundPositionX: `${mousePosition.x}%`,
                  backgroundPositionY: `${mousePosition.y}%`,
                }}
              />
            )}
            {isDesktop && !isOutOfStock && (
              <div className="absolute top-4 right-4 bg-white/80 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <ZoomIn className="w-5 h-5 text-gray-600" />
              </div>
            )}
          </>
        )}
      </div>
      <div className="mt-4 md:mt-6 grid grid-cols-4 gap-2 md:gap-3">
        {images?.map((image, index) => (
          <button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`relative aspect-square rounded-lg overflow-hidden transition-all duration-300 ${
              currentImage === index
                ? "ring-2 ring-red-500 shadow-md"
                : "ring-1 ring-gray-200 opacity-70 hover:opacity-100"
            } ${isOutOfStock ? "grayscale" : ""}`}
          >
            <Image
              src={image}
              alt={`Thumbnail ${index + 1}`}
              fill
              sizes="(max-width: 768px) 25vw, 10vw"
              className="object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>
    </div>
  )
);

export default ImageGallery;